import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* The sidebar's Dashboards icon. */}
    <g transform="translate(0 2)">
      <rect x="2" y="3" width="20" height="14" rx="3" />
      <path d="M10 7V13M6 10V13" />
      <circle cx="16" cy="10" r="2" />
    </g>
  </ContentTile>
);
